/**
 * 该参数类型仅针对桌面应用类型下的窗口参数
 */
export interface BrowserWindowConstructorOptions {
  /**
   * Window's width in pixels. Default is `1280`.
   */
  width?: number
  /**
   * Window's height in pixels. Default is `720`.
   */
  height?: number
  /**
   * (**required** if y is used) Window's left offset from screen. Default is to
   * center the window.
   */
  x?: number
  /**
   * (**required** if x is used) Window's top offset from screen. Default is to
   * center the window.
   */
  y?: number
  /**
   * Whether to allow page title modification
   */
  enableModifyPageTitle?: boolean
  title?: string
  isFullPath?: boolean
}

export interface IElectronUtils {
  openInNewWindow: (pageURL: string, browserWindowOptions?: BrowserWindowConstructorOptions) => void
}

export const useElectron = () => window?.$_pcEnv
